module.exports = __webpack_public_path__ + "assets/img/contraband1.382dc078.png";